module.exports = __webpack_public_path__ + "static/media/seamstress.df532a84.svg";